module.exports = __webpack_public_path__ + "img/10.5d659606.png";